import { Component, type ReactNode } from 'react';
import { appInsights } from '../lib/appInsights';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    appInsights?.trackException({ exception: error, properties: { componentStack: info.componentStack } });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="p-8">
          <h2 className="text-xl font-bold mb-2">Something went wrong</h2>
          <p className="text-text-muted">{this.state.error.message}</p>
        </div>
      );
    }
    return this.props.children;
  }
}
